import React from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { handlAuthUserType } from '../../../reducersAndActions/actions/authAction';
import { useAuth } from '../../../contexts/auth';
import { usePopup } from '../../../hooks';
import styles from './Header.module.scss';
import {
  andriodSource,
  clearLocalStorage,
  env,
  getContractTypeVal,
  getCookie,
  getProjectId,
  getQueryVariable,
  getSourceValue,
  iosSource,
  pathsObj,
  touchSource,
  trackUserType,
  webSource,
} from '../../../lib/common';
import Tooltip from '../Tooltip/Tooltip';
import { sendCommunication, getClickTrackersInfo } from '../../../api';

function Header() {
  const navigate = useNavigate();
  const [authState, dispatch] = useAuth();
  const [setPopup] = usePopup();
  const { type, selectedBusiness, sidResponse } = authState;
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const loginType = searchParams.get('type');
  const FooterFlag = searchParams.get('footerFlag');
  const pageType = location.pathname.replace('/csportal', '').replace('/', '') || 'landing';
  const faqType = location.pathname.replace('/csportal/faq', '').replace('/', '') || '';
  const source = getSourceValue();
  const qSource = getQueryVariable('source') || source || '';
  const projectId = getProjectId();
  const contractType = getContractTypeVal(projectId);

  const getUserDetails = () => {
    try {
      return sessionStorage.getItem('userDetails') ? JSON.parse(sessionStorage.getItem('userDetails')) || {} : {};
    } catch {
      console.log('Err in parsing getUserDetails');
      return {};
    }
  };
  const userDetails = getUserDetails();
  const contractVal = getContractTypeVal('csportal');

  const hasPath = [
    'ecs',
    'edit_business',
    'contract',
    'leads',
    'payments',
    'payment_history',
    'create_ticket',
    'grievance',
  ].includes(pageType);

  const callSendCommunication = async () => {
    try {
      const params = {
        mobile: userDetails?.mobile || '',
        email_id: userDetails?.email || '',
      };
      await sendCommunication(params);
      sessionStorage.setItem('communicationSentFlag', 1);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleGoBack = async () => {
    const manageCampaign = getQueryVariable('bachfrom');
    const redirect = getQueryVariable('rd');
    const redirectHome = getQueryVariable('redirect');
    const vertical = getQueryVariable('vertical');
    const jdlite = getQueryVariable('jdlite');
    const back = getQueryVariable('back');
    

    if (pageType === 'landing' && back === '1' && (andriodSource.includes(source) || iosSource.includes(source))) {
      window.location = 'https://jdext.php/';
      return null;
    }

    if (loginType && !sidResponse) {
      const newUrl = location.pathname;
      handlAuthUserType(dispatch, '');
      sessionStorage.removeItem('landingPageUserType');
      navigate(newUrl, { replace: true });
      return null;
    }
    sessionStorage.setItem('headerback', 1);
    if (contractVal && contractVal !== 'free' && !sessionStorage.getItem('communicationSentFlag')) {
      await callSendCommunication();
    }

    if (window.location.pathname === '/csportal' && jdlite && [2, '2'].includes(source)) {
      clearLocalStorage();
      window.location = 'https://justdial.com/jdext.php';
      return null;
    }

    if (pageType === 'landing' && (andriodSource.includes(source) || iosSource.includes(source))) {
      clearLocalStorage();
      window.location = 'https://jdext.php/';
      return null;
    }

    if (window.location.pathname === '/csportal' && [3, '3', 1, '1', '21', 21].includes(source)) {
      if (vertical && !touchSource.includes(qSource)) {
        navigate(-1);
        return null;
      }
      clearLocalStorage();
      window.location = 'https://www.justdial.com/jdext.php';
      return null;
    }

    if (redirect === '1' || redirect === 1 || redirectHome === 'home') {
      window.location = 'https://cs.justdial.com/csportal?back=1';
    }

    if (manageCampaign && manageCampaign === 'managecampaign') {
      navigate(-3);
    }

    if (window.history.length === 1) {
      window.location = 'https://www.justdial.com';
    }

    if (!sidResponse && FooterFlag === '1') {
      handlAuthUserType(dispatch, '');
    }

    if (pageType === 'edit_business' && (touchSource.includes(source) || webSource.includes(source))) {
      navigate(-2);
      return null;
    }
    
   
    // if (pageType === 'landing') {
    //   clearLocalStorage();
    //   window.close();
    // }
    navigate(-1);
    return null;
  };

  const headerTitle = hasPath ? pathsObj[pageType] || '' : pathsObj[faqType] || '';
  const dataCity = selectedBusiness && selectedBusiness.data_city ? selectedBusiness.data_city : '';

  const handleOnLanding = async (liVal = '', liTrd = '', faqTypeVal = '', othersData = []) => {
    try {
      let sessionId = getCookie('session_id');
      if (!sessionId) {
        sessionStorage.setItem('session_id', sessionId);
      }
      if (!sessionId) {
        sessionId = Math.random().toString(36).slice(2);
        document.cookie = `session_id=${sessionId}; path=/;`;
        sessionStorage.setItem('session_id', sessionId);
      }
      if (sessionId) {
        const jduId = userDetails?.jduid || '';
        const sectionOthersData = othersData?.map((item) => item.title);

        const trdObj = {
          cname: selectedBusiness?.compname || '',
          cta_name: '',
          docid: selectedBusiness?.docid || '',
          city: selectedBusiness?.city || '',
          dcity: selectedBusiness?.data_city || '',
          area: selectedBusiness?.areaname || '',
          pin: selectedBusiness?.pincode || '',
          ds: '',
          pdg: '',
          paid: selectedBusiness?.paidstatus || '',
          usertype: authState?.sidResponse ? `${trackUserType?.[contractType]}` : 'non_login',
          jd_verified: '',
          guarantee: '',
          trust: '',
          verified: '',
          tag: '',
          pos: '',
          li: liTrd,
          sections: [],
        };
        if (liTrd === 'landing') {
          trdObj.sections = [];
          trdObj.cta_name = ['Chat with Us', 'Get a Callback'];
        }
        if (liVal === 'click') {
          trdObj.sections = faqTypeVal === 'Others' ? sectionOthersData : '';
          trdObj.cta_name = '';
        }

        const paramsData = {
          session_id: sessionId,
          search_id: sessionId,
          trd: [trdObj],
          li: liVal,
          ll: 'cshmpg',
          referrer: 'auto',
          user_ip: '',
          city: selectedBusiness?.city || '',
          data_city: selectedBusiness?.data_city || '',
          area: selectedBusiness?.areaname || '',
          pincode: selectedBusiness?.pincode || '',
          jduid: jduId || '',
          mobile: userDetails?.mobile || '',
          request_time: '',
          device_src: getCookie('device_src') || '2',
          device_id: '',
          category_name: '',
          user_agent: '',
          sid: getCookie('sid') || '',
          jde: '',
          vid: '615',
          env,
          utm_source: '',
          utm_medium: '',
          utm_campaign: '',
          app_version: '',
          transaction_id: '',
        };
        await getClickTrackersInfo(paramsData);
      }
    } catch (err) {
      console.log('ERROR in handleClickTrackers', err);
    }
  };

  return (
    <header className={`${styles.header_box} ${styles.header_blue} `}>
      <div className={`${styles.header_left}`}>
        <div
          aria-label="header_back_btn"
          tabIndex={0}
          role="button"
          onKeyDown={() => {}}
          className={`csicon ${styles.page_whiteback_icon} `}
          id="headerback"
          onClick={() => handleGoBack()}
        />
      </div>
      <div className={`${styles.header_center}`}>
        <div className={`${styles.header_text} text_center`}>
          {type === 'business' ? (
            <div
              aria-label="csheader_text_popup"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              className="csheader_text text_center"
              onClick={() => {
                if (sidResponse && pageType === 'landing') {
                  document.body.style.overflow = 'hidden';
                  const liVal = 'click';
                  const liTrd = `select_business`;
                  handleOnLanding(liVal, liTrd);
                  setPopup({ open: true, popupType: 'selectBusiness' });
                }
              }}
            >
              <div className="font14 fw600 colorFFF text-center">
                {headerTitle && <div>{headerTitle}</div>}
                <div>
                  <Tooltip text={selectedBusiness?.compname?.length > 20 ? selectedBusiness?.compname : ''}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <div className={`${selectedBusiness?.compname?.length > 20 ? 'business-title-header' : ''}`}>
                        {selectedBusiness?.compname
                          ? selectedBusiness?.compname
                          : headerTitle
                            ? ''
                            : 'Customer Support'}
                      </div>
                      {sidResponse && pageType === 'landing' && (
                        <div>
                          <img
                            className="ml-8"
                            alt="angle_down_black"
                            src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/expand_more_icon.svg"
                          />
                        </div>
                      )}
                    </div>
                  </Tooltip>
                </div>
              </div>
              {!headerTitle && (
                <div className="font11 fw400 colorFFF business-area-subtitle-header">
                  {`${selectedBusiness.areaname ? `${selectedBusiness.areaname},` : ''} ${dataCity && dataCity}`}
                </div>
              )}
            </div>
          ) : (
            <div className="font14 fw600 colorFFF text-center">
              {type === 'user' && sidResponse ? 'User Feedback' : 'Customer Support'}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
